<template>
  <div class="animated fadeIn" id="list-beneficiaires">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-card>
              <b-form v-on:submit.prevent="search">
                <b-row>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="id_pp"><strong>N°Identifiant NSI</strong></label>
                      <b-form-input type="text" id="id_pp" v-model="idpp_criteria" :class="{hasError: errors.idpp_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.idpp_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="num_dossier"><strong>N° Dossier</strong></label>
                      <b-form-input type="text" id="num_dossier" v-model="dossier_criteria" :class="{hasError: errors.dossier_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.dossier_criteria }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="nir"><strong>N° Sécurité Sociale</strong></label>
                      <b-form-input type="text" id="nir" v-model="nir_criteria" :class="{hasError: errors.nir_criteria !== ''}"></b-form-input>
                      <span class="field-error">{{ errors.nir_criteria }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                   <b-col sm="4">
                    <b-form-group >
                      <label for="nom"><strong>Nom</strong></label>
                      <b-form-input type="text" id="nom" v-model="nom_criteria"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                   <b-form-group >
                      <label for="prenom"><strong>Prénom</strong></label>
                      <b-form-input type="text" id="prenom" v-model="prenom_criteria"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="email"><strong>Email</strong></label>
                      <b-form-input type="text" id="email" v-model="email_criteria"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="active"><strong>Compte</strong></label>
                      <!-- Il s'agit de la colonne "active" de la table login, indiquant si le bénéficiaire a activé son compte ou non  -->
                      <b-form-radio-group id="active" v-model="active">
                        <b-form-radio value="tous">Tous</b-form-radio>
                        <b-form-radio value="true">Activé</b-form-radio>
                        <b-form-radio value="false">Non activé</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="is_active"><strong>Etat du bénéficiaire</strong></label>
                      <!-- Il s'agit de la colonne "is_active" de la table users, indiquant si le bénéficiaire est considéré comme décédé ou non  -->
                      <b-form-radio-group id="is_active" v-model="is_active" name="is_active">
                        <b-form-radio value="null">Tous</b-form-radio>
                        <b-form-radio value="false">Inactif <span id="is_active-tooltip" class="ml-1" @click.prevent=""><i class="fa fa-question-circle orange-question"></i></span></b-form-radio>
                        <b-form-radio value="true">Actif</b-form-radio>
                      </b-form-radio-group>
                      <b-tooltip target="is_active-tooltip" placement="top">Bénéficiaires n'ayant pas reçu de décompte depuis plus de 6 mois.</b-tooltip>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div slot="footer">
                  <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                    <i class="fa fa-eraser"></i> Effacer
                  </b-button>
                  <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                    <i class="fa fa-search"></i> Rechercher
                  </b-button>
                </div>
              </b-form>
            </b-card>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Bénéficiaires</strong>
      </b-card-header>
      <b-card-body>
        <beneficiaire-table :tableEntry="tableParam" ref="beneficiaire_table"></beneficiaire-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import BeneficiaireTable from '../../components/BeneficiaireTable'

export default {
  components: { BeneficiaireTable },
  data() {
    return {
      columns: ["id_pp", "nir", "nom", "prenom", "numero_tel", "date_naissance", "is_active"],
      items: [],
      options: {
        headings: {
          id_pp: "N°Identifiant NSI",
          num_dossier: "N° dossier",
          nir: "N° Sécu. Soc.",
          nom: "Nom",
          prenom: "Prénom",
          numero_tel: "Téléphone",
          date_naissance: "Date de naissance",
          is_active: "Contactable"
        },
        sortable: ["nom", "prenom"],
        filterable: ["nom", "prenom", "id_pp", "nir", "date_naissance"],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "N°Identifiant NSI, Nom, Prénom, N° SS, Date naissance"
        },
        // orderBy: { ascending: false}
      },
      idpp_criteria: '',
      dossier_criteria: '',
      nir_criteria: '',
      active: 'tous',
      nom_criteria: '',
      prenom_criteria: '',
      email_criteria: '',
      is_active: null,
      noSearch: 'noSearch',
      errors: { idpp_criteria: '', dossier_criteria: '', nir_criteria: '' }
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    if (this.$route.query.in) {
      this.idpp_criteria = this.$route.query.in
    }
    if (this.$route.query.do) {
      this.dossier_criteria = this.$route.query.do
    }
    if (this.$route.query.ns) {
      this.nir_criteria = this.$route.query.ns
    }
    if (this.$route.query.no) {
      this.nom_criteria = this.$route.query.no
    }
    if (this.$route.query.pr) {
      this.prenom_criteria = this.$route.query.pr
    }
    if (this.$route.query.em) {
      this.email_criteria = this.$route.query.em
    }
    if (this.$route.query.co) {
      this.active = this.$route.query.co
    }
    if (this.$route.query.de) {
      this.is_active = this.$route.query.de
    }
    // Si co alors retour d'une fiche suite à recherche, donc noSearch vide
    if (this.$route.query.co) {
      this.noSearch = ''
    }
  },
  computed: {
    tableParam: {
      get() {
        let request = {};

        request.dossier_criteria = this.dossier_criteria.replace(/ /g, "")
        this.dossier_criteria = request.dossier_criteria
        request.idpp_criteria = this.idpp_criteria.replace(/ /g, "")
        this.idpp_criteria = request.idpp_criteria
        request.nir_criteria = this.nir_criteria.replace(/ /g, "")
        this.nir_criteria = request.nir_criteria
        request.nom_criteria = this.nom_criteria;
        request.prenom_criteria = this.prenom_criteria;
        request.email_criteria = this.email_criteria;
        request.active = this.active;
        request.is_active = this.is_active;
        request.noSearch = this.noSearch;

        return request;
      }
    },
  },
  methods: {
    search() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true)
        this.noSearch = ''
        setTimeout(this.$refs.beneficiaire_table.$refs.table.refresh(), 3000);
        
      }
    },
    validateData() {
      this.clearErrors()
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true

      let idpp = this.idpp_criteria.replace(/ /g, "")
      if (idpp !== '') {
        if (!regNumeric.test(idpp)) {
          this.errors.idpp_criteria = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
          valid = false
        }
        else if (idpp.length > 9 || idpp.length < 9) {
          this.errors.idpp_criteria = 'Un N°Identifiant NSI doit contenir exactement 9 chiffres'
          valid = false
        }
      }
      let num_dossier = this.dossier_criteria.replace(/ /g, "")
      if (num_dossier !== '') {
        if (!regNumeric.test(num_dossier)) {
          this.errors.dossier_criteria = 'Un N° Dossier ne doit contenir que des chiffres'
          valid = false
        }
      }
      let nir = this.nir_criteria.replace(/ /g, "")
      if (nir !== '') {
        if (!regNumeric.test(nir)) {
          this.errors.nir_criteria = 'Un N° de sécurité sociale ne doit contenir que des chiffres'
          valid = false
        }
        else if (nir.length > 13 || nir.length < 13) {
          this.errors.nir_criteria = 'Un N° de sécurité sociale doit contenir exactement 13 chiffres'
          valid = false
        }
      }
      return valid
    },
    clearErrors() {
      this.errors.idpp_criteria = ''
      this.errors.dossier_criteria = ''
      this.errors.nir_criteria = ''

    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir.length === 15){
        return textNir.substring(0,13);
      }else{
        return textNir;
      }
    },
    fiche(id) {
      // this.$router.push({ path: '/espace-beneficiaire/beneficiaires/fiche/' + id })
      this.$router.push({ path: "/espace-beneficiaire/beneficiaires/fiche/" + id, query: { in: this.idpp_criteria, do: this.dossier_criteria, ns: this.nir_criteria, no: this.nom_criteria, pr: this.prenom_criteria, em: this.email_criteria, co: this.active, de: this.is_active }})
    },
    clearForm() {
      this.idpp_criteria = '' 
      this.dossier_criteria = ''
      this.nir_criteria = ''
      this.nom_criteria = ''
      this.prenom_criteria = ''
      this.email_criteria = ''
      this.active = 'tous'
      this.is_active = null
    }
  }
};
</script>

<style>
.fiche-beneficiaire {
  cursor: pointer;
}
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
}

#list-beneficiaires .VueTables__table thead tr th:first-child {
  width: 10%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(2) {
  width: 10%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(3) {
  width: 27%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(4) {
  width: 26%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(5) {
  width: 10%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(6) {
  width: 10%;
}
#list-beneficiaires .VueTables__table thead tr th:nth-child(7) {
  width: 7%;
}
</style>

